import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class TemplateService {

  public header: EventEmitter<any> = new EventEmitter<any>();
  public mobileMenuOpen: EventEmitter<any> = new EventEmitter<any>();
  public backref: EventEmitter<{[key: string]: any}> = new EventEmitter<{[key: string]: any}>();
  private lastData;

  public setHeader(text) {
    this.header.emit(text);
  }

  public setBackref(data: {[key: string]: any}) {
    if (data.url === '/objects/search/vitrina' && this.lastData && this.lastData.url.includes('commercial')) {
      // исключенмие для предотвращения сбрасывания значения кнопки "Назад" при переходе на каталог с интерфейса коммерческой недвижимости
      this.backref.emit(this.lastData);
    } else {
      this.backref.emit(data);
      this.lastData = data;
    }
  }

  constructor() { }

}
